import { createAsyncThunk } from "@reduxjs/toolkit";
import fieldsApi from "api/fieldsApi";
import { formatQueryParams } from "helpers/format";

export const getFields = createAsyncThunk(
  "Fields",
  async (params: any = {}) => {
    try {
      const response = await fieldsApi.getFields(formatQueryParams(params));
      return response;
    } catch (error) {
      return error;
    }
  }
);
